import { AppRemixIcon } from '@/layout/AppComponents';
import colors from '../../../../../../constants/colors';
import { getEvaluationName } from '../../tools/environmentalAspectsAssessmentTools';

export default function EvaluationSidebarElement({ evaluation }) {
  return (
    <>
        <div className="first-row">
            <span className="name">
                {getEvaluationName(evaluation.evaluation)}
            </span>
            <AppRemixIcon
                icon="attachment-2"
                noVariants
                color={
                    evaluation?.files && (evaluation?.files?.length > 0 || Object.keys(evaluation?.files).length)
                    ? colors.primary
                    : colors.grey300
                }
                title={
                    evaluation?.files && (evaluation?.files?.length > 0 || Object.keys(evaluation?.files).length)
                    ? 'Contiene archivo/s'
                    : 'No contiene archivo/s'
                }
            />
        </div>
        <div className="second-row">
            <span className="sr-date">{evaluation.evaluationDateStamp}</span>
            <AppRemixIcon
                icon="chat-3"
                color={
                    evaluation?.comment
                    ? colors.primary
                    : colors.grey300
                }
                title={
                    evaluation?.comment
                    ? 'Contiene comentario'
                    : 'No contiene comentario'
                }
            />
        </div>
        <div className="first-row">
            <span className="name">
                {evaluation.nonConformityCode}
            </span>
        </div>
        <div className="first-row">
            <span className="name">
                {evaluation.userName}
            </span>
        </div>
    </>
  );
}